import React from 'react'

const Wisglist = () => {
  return (
    <div>
      <>




<div classname="card my-2" style={{width: "18rem" , padding:"0px 0px 10px 0px", border:"1px solid  grey" , margin:"2vh"}}>
<img src="https://cdn0.weddingwire.in/vendor/0848/3_2/1280/jpg/hotels-chomu-palace-hotel-entrance-decor-2_15_50848-163715260334041.jpeg" classname="card-img-top" alt="..."  style={{ width:"240px" , transform: "translateX(10%)"}}/>
<div classname="card-body">
    <h5 classname="card-title" style={{ transform: "translateX(10%)"}}>title</h5>
    <p classname="card-text"style={{ transform: "translateX(8%)"}}>description</p>

    {/* <a href="/" classname="btn btn-primary">Go somewhere</a> */}
</div>
</div>

</>
    </div>
  )
}

export default Wisglist
